/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `aluminium_aerosol` - Aluminium Aerosol
 * * `food_can` - Food Can
 * * `non_metal` - Non Metal
 * * `other_aluminium` - Other Aluminium
 * * `other_metal` - Other Metal
 * * `ubc` - UBC
 * * `foil_and_tray` - Foil and Tray
 * * `clear` - Clear
 * * `white` - White
 * * `opaque` - Opaque
 * * `brown` - Brown
 * * `light_blue` - Light Blue
 * * `dark_blue` - Dark Blue
 * * `green` - Green
 * * `other_colour` - Other Colour
 * * `clear_non_food_grade` - Clear Non Food Grade
 * * `clear_full_sleeve_non_food_grade` - Clear Full Sleeve Non-Food Grade
 * * `clear_pet_tray` - Clear PET Tray
 * * `pet_tray_contaminated_clear` - Clear Contaminated PET Tray
 * * `film` - Film
 * * `other_plastic` - Other Plastic
 * * `polypropylene` - PP
 * * `non_plastic` - Non Plastic
 * * `metal` - Metal
 * * `prohibitive` - Prohibitive
 * * `full_sleeve` - Full Sleeve Bottle
 * * `oil_bottle` - Oil Bottle
 * * `pet_bottle_dirty` - Dirty Bottles
 * * `hdpe_natural_food_grade` - HDPE Natural Food Grade
 * * `hdpe_natural_non_food_grade` - HDPE Natural Non-Food Grade
 * * `hdpe_white_food_grade` - HDPE White Food Grade
 * * `hdpe_white_non_food_grade` - HDPE White Non-Food Grade
 * * `hdpe_silicon_tubes` - HDPE Silicon Tubes
 * * `hdpe_jazz` - HDPE Jazz
 * * `hdpe_green` - HDPE Green
 * * `hdpe_blue` - HDPE Blue
 * * `hdpe_purple` - HDPE Purple
 * * `hdpe_red` - HDPE Red
 * * `hdpe_orange` - HDPE Orange
 * * `hdpe_yellow` - HDPE Yellow
 * * `hdpe_brown` - HDPE Brown
 * * `hdpe_black` - HDPE Black
 * * `expanded_polystyrene` - Expanded Polystyrene
 * * `pet` - PET
 * * `waste` - Waste
 */
export type Operand = typeof Operand[keyof typeof Operand];


export const Operand = {
  aluminium_aerosol: 'aluminium_aerosol',
  food_can: 'food_can',
  non_metal: 'non_metal',
  other_aluminium: 'other_aluminium',
  other_metal: 'other_metal',
  ubc: 'ubc',
  foil_and_tray: 'foil_and_tray',
  clear: 'clear',
  white: 'white',
  opaque: 'opaque',
  brown: 'brown',
  light_blue: 'light_blue',
  dark_blue: 'dark_blue',
  green: 'green',
  other_colour: 'other_colour',
  clear_non_food_grade: 'clear_non_food_grade',
  clear_full_sleeve_non_food_grade: 'clear_full_sleeve_non_food_grade',
  clear_pet_tray: 'clear_pet_tray',
  pet_tray_contaminated_clear: 'pet_tray_contaminated_clear',
  film: 'film',
  other_plastic: 'other_plastic',
  polypropylene: 'polypropylene',
  non_plastic: 'non_plastic',
  metal: 'metal',
  prohibitive: 'prohibitive',
  full_sleeve: 'full_sleeve',
  oil_bottle: 'oil_bottle',
  pet_bottle_dirty: 'pet_bottle_dirty',
  hdpe_natural_food_grade: 'hdpe_natural_food_grade',
  hdpe_natural_non_food_grade: 'hdpe_natural_non_food_grade',
  hdpe_white_food_grade: 'hdpe_white_food_grade',
  hdpe_white_non_food_grade: 'hdpe_white_non_food_grade',
  hdpe_silicon_tubes: 'hdpe_silicon_tubes',
  hdpe_jazz: 'hdpe_jazz',
  hdpe_green: 'hdpe_green',
  hdpe_blue: 'hdpe_blue',
  hdpe_purple: 'hdpe_purple',
  hdpe_red: 'hdpe_red',
  hdpe_orange: 'hdpe_orange',
  hdpe_yellow: 'hdpe_yellow',
  hdpe_brown: 'hdpe_brown',
  hdpe_black: 'hdpe_black',
  expanded_polystyrene: 'expanded_polystyrene',
  pet: 'pet',
  waste: 'waste',
} as const;
